// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// ** API Imports
import axios from '@src/service/axios';

import { toast } from 'react-toastify';

export const getCustomer = createAsyncThunk('customerSliceData/getCustomer', async () => {
    try {
        let response = await axios.get('/Customer', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getCustomeroptions = createAsyncThunk('customerSliceData/getCustomeroptions', async () => {
    try {
        let response = await axios.get('/Customer?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const getCustomerById = createAsyncThunk('customerSliceData/getCustomerById', async (id) => {
    try {
        let response = await axios.get('/Customer/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getCustomerStatus = createAsyncThunk('customerSliceData/getCustomerStatus', async () => {
    try {
        let response = await axios.get('/Customer?status=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const deleteCustomer = createAsyncThunk('customerSliceData/deleteCustomer', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/Customer/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Customer deleted successfully.');
        await dispatch(getCustomer());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const createCustomer = createAsyncThunk('customerSliceData/createCustomer', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/Customer', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Customer added succesfully.');
        await dispatch(getCustomer());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateCustomer = createAsyncThunk('customerSliceData/updateCustomer', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/Customer/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Customer updated succesfully.');
        await dispatch(getCustomer());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateCustomerStatus = createAsyncThunk('customerSliceData/updateCustomerStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/Customer/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status Updated Succesfully');
        await dispatch(getCustomer());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const customerslice = createSlice({
    name: 'customerSliceData',
    initialState: {
        customer: [],
        customeroption: [],
        customerdata: {}
    },
    extraReducers: (builder) => {
        builder.addCase(getCustomer.fulfilled, (state, action) => {
            state.customer = action?.payload;
            return;
        });
        builder.addCase(getCustomeroptions.fulfilled, (state, action) => {
            state.customeroption = action?.payload;
            return;
        });
        builder.addCase(getCustomerById.fulfilled, (state, action) => {
            state.customerdata = action?.payload;
            return;
        });
    }
});

export default customerslice.reducer;
